module.exports = __webpack_public_path__ + "img/ff2.36f90a11.png";